/* ═══ "VER MAIS" NA CATEGORIA — carrega a página seguinte abaixo ════════════
   🔑 O LINK É A BASE, O SCRIPT É O ENFEITE. O botão já é um `<a href>` real
     para a página 2: sem JavaScript ele navega, o Google indexa, e quem usa
     leitor de tela chega lá do mesmo jeito. Este arquivo só INTERCEPTA o
     clique e traz o conteúdo para baixo do que já está na tela.

   🪤 A GRADE DE PRODUTO TEM CARTÕES QUE NÃO SÃO PRODUTO. Na página 1 entram
     um cartaz de material e um de faixa, posicionados por índice — e eles NÃO
     podem ser copiados da página 2, senão apareceriam duas vezes. Por isso o
     que se copia são os `.pc`, um a um, e não a grade inteira.

   🪤 A URL DA BARRA MUDA JUNTO. Sem isso, recarregar a página depois de abrir
     três blocos volta ao primeiro — e quem chegou aqui por um link com filtro
     perderia o filtro. `replaceState` não cria entrada no histórico: o botão
     "voltar" continua levando de onde a pessoa veio, não para o meio da lista.

   ⚠️ O ESTADO DO CORAÇÃO se aplica aos cartões novos porque o
     `ettore-favoritos.js` ouve o evento e re-sincroniza; aqui só disparamos. */
(function () {
  'use strict';
  var caixa = document.querySelector('[data-vermais]');
  if (!caixa) return;
  var bt = caixa.querySelector('[data-vermais-bt]');
  if (!bt) return;
  var carregando = false;
  var io = null;

  bt.addEventListener('click', function (e) {
    e.preventDefault();
    carrega(false);
  });

  /* ═══ ABRE SOZINHO AO ROLAR — [2026-10-03], pedido dele ═══════════════════
     *"em vez de ela clicar de abrir mais, abre sozinho"*. O botão continua
     existindo (sem JS, sem IntersectionObserver, ou se a carga falhar), mas
     quem rola chega ao fim da grade e as peças já estão descendo.
     🔑 `rootMargin` de 800px embaixo: a carga começa ANTES de o botão
       aparecer, e quem rola não vê o "Carregando…" — vê as peças.
     🪤 No automático, ERRO NÃO NAVEGA. O `catch` do clique leva à página 2
       porque a pessoa pediu; tirar alguém da página sem ela pedir seria pior
       que não carregar. Volta o botão, e ela clica se quiser.
     🪤 O observador olha a CAIXA, não o botão: o botão some na última
       página, e observar um nó removido não dispara nada — fica o desligar
       explícito quando acaba. */
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entradas) {
      entradas.forEach(function (en) {
        if (!en.isIntersecting) return;
        if (!caixa.querySelector('[data-vermais-bt]')) { io.disconnect(); return; }
        carrega(true);
      });
    }, { rootMargin: '0px 0px 800px 0px' });
    io.observe(caixa);
  }

  function carrega(auto) {
    if (carregando) return;
    carregando = true;
    var trouxe = false;
    var url = bt.getAttribute('href');
    /* 🪤 innerHTML, NÃO textContent — [2026-08-29]. O rótulo de restauração era
       `textContent = rotulo`, que apagava a SETA (svg) no primeiro clique. E o
       botão agora DIZ que está carregando: ele clicou, nada mudou na tela e
       atualizou no meio — o F5 caiu na ?page=2 crua, "foi pra outra página". */
    var rotuloHTML = bt.innerHTML;
    bt.classList.add('carregando');
    bt.setAttribute('aria-busy', 'true');
    bt.textContent = 'Carregando…';

    fetch(url, { headers: { 'X-Requested-With': 'fetch' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        /* 🔴 ERA `document.querySelector('.grade, [class*="grade"]')` E PÔS AS
           PEÇAS NOVAS NO LUGAR ERRADO. `querySelector` com lista devolve o
           PRIMEIRO no documento que casa com QUALQUER um dos seletores — e
           `.miolo-grade` (um `display:block` que embrulha a seção) vem antes da
           `.grade` de verdade. As 9 peças carregadas caíam nesse bloco: sem
           colunas, cada uma esticava para 1.028px, e a página que estava com
           quatro por fileira passava a mostrar cartazes gigantes emendados na
           grade certa.
           🔑 O PAI DE UM CARTÃO QUE JÁ ESTÁ NA TELA não tem como errar: seja
             qual for o nome da classe hoje ou amanhã, é ali que os cartões
             moram. Nome de classe é palpite; o DOM é medida. */
        /* 🔴 E O DESTINO TINHA O MESMO DEFEITO DA ORIGEM — [2026-08-29]. O
           `document.querySelector('.pc')` pega o PRIMEIRO card do documento,
           que é o de uma seção ACIMA da grade (medido: um pai com 4 cards
           recebendo os novos). Ele clicava e as peças não apareciam embaixo
           da grade — entravam noutra seção. O pai do `.vermais` LOCAL é o
           contêiner da grade verdadeira, igual do lado do doc. */
        var zonaLocal = caixa.parentElement;
        var pcAtual = (zonaLocal && zonaLocal.querySelector('.pc')) || document.querySelector('.pc');
        var grade = pcAtual && pcAtual.parentElement;
        /* 🔴 ERA `doc.querySelectorAll('.pc')` — o DOCUMENTO INTEIRO da página
           seguinte, e a página tem .pc FORA da grade (outras seções). Medido em
           /collections/all: a página 2 tem 7 produtos e o clique trazia 13 —
           seis cartões de outra seção entravam DUPLICADOS na grade, e o
           contador fechava em "35 de 27 peças", que foi o que ele fotografou.
           A zona certa é o pai do `.vermais` do doc: é o mesmo contêiner da
           grade, e as células especiais só existem na página 1. */
        var vermaisDoc = doc.querySelector('.vermais');
        var zona = vermaisDoc ? vermaisDoc.parentElement : null;
        var novos = zona ? zona.querySelectorAll('.pc') : [];
        if (!grade || !novos.length) { if (!auto) location.href = url; return; }

        novos.forEach(function (c) { grade.appendChild(document.importNode(c, true)); });
        trouxe = true;

        /* o botão passa a apontar para a página seguinte, ou some se acabou */
        var proximo = doc.querySelector('[data-vermais-bt]');
        if (proximo) {
          bt.setAttribute('href', proximo.getAttribute('href'));
        } else {
          caixa.querySelector('[data-vermais-bt]').remove();
        }
        /* na última página o doc não tem [data-vermais-vistos] — tem a conta
           fechada "N de N peças". O fallback antigo contava TODOS os .pc do
           documento e escrevia 35 onde a coleção tem 27. */
        var vistos = caixa.querySelector('[data-vermais-vistos]');
        var novosVistos = doc.querySelector('[data-vermais-vistos]');
        var contaDoc = doc.querySelector('.vermais-conta');
        var contaLocal = caixa.querySelector('.vermais-conta');
        if (vistos && novosVistos) vistos.textContent = novosVistos.textContent;
        else if (contaLocal && contaDoc) contaLocal.textContent = contaDoc.textContent.trim();

        history.replaceState(null, '', url);
        document.dispatchEvent(new CustomEvent('ettore:favoritos', { detail: null }));
      })
      .catch(function () { if (!auto) location.href = url; })   /* clique que deu errado: navega, como faria sem script */
      .finally(function () {
        carregando = false;
        bt.classList.remove('carregando');
        bt.removeAttribute('aria-busy');
        if (bt.isConnected) bt.innerHTML = rotuloHTML;
        /* se as peças novas não bastaram para empurrar a caixa para fora da
           margem, o observador não dispara de novo sozinho (não houve
           "entrada") — reobservar força a conferência. Só depois de SUCESSO:
           reobservar depois de erro repetiria o pedido sem fim. */
        if (auto && trouxe && io && bt.isConnected) { io.unobserve(caixa); io.observe(caixa); }
      });
  }
})();
